import ProductCatalogsProvider from '../providers/product-catalogs-provider';

class ProductCatalogsRepository {

    constructor() {
        this.productCatalogsProvider = new ProductCatalogsProvider();
    }

    getObtenerCatalogos = async () => {
        return this.productCatalogsProvider.getObtenerCatalogos();
    }

}

export default ProductCatalogsRepository;